import { Chart, ChartEvent } from 'chart.js'

import { TChartClick } from '../types'

export const handleOnSegmentClick = (params: {
  _active: unknown
  callback: (params: TChartClick) => void
  chart: Chart
  event: ChartEvent
}) => {
  const { callback, chart, event } = params
  const data = chart.data
  const labels = data.labels ?? []

  const native = (event as any)?.native

  if (!native) return

  const rect = chart.canvas.getBoundingClientRect()

  const left = rect.left + native.offsetX + window.scrollX
  const top = rect.top + native.offsetY + window.scrollY

  const hits = chart.getElementsAtEventForMode(
    event as unknown as Event,
    'nearest',
    { intersect: true },
    true
  )

  if (hits.length) {
    const { index, datasetIndex } = hits[0]

    if (!(data.datasets[datasetIndex] as any).main) return

    callback({
      datasetIndex,
      datasetLabel: data.datasets?.[datasetIndex].label,
      index,
      label: String(labels[index]),
      position: { left, top },
      value:
        data.datasets?.[datasetIndex].data?.[index] != null
          ? Number(data.datasets[datasetIndex].data[index])
          : undefined
    })

    return
  }
}
